/**
 * base API service
 *
 * provide : methods : PUT, PATCH, DELETE, GET, POST,...
 *
 */

import {Injectable} from '@angular/core';

// Import RxJs required methods



@Injectable()
export class SelectService {

    public data: any = {
        'list': {},
        'listDisabled': {}
    };
}
